<template>
  <div v-if="addTrack" class="popup-overlay">
    <div class="popup-content">
      <h3>Salva i tuoi risultati</h3>
      <p>Inserisci i risultati del tuo workout</p>
      <form @submit.prevent="handleSubmit">
          <div class="row">
            <div class="form-group col-sm-12">
              <label>Tempo / Numero di round</label>
              <input
                type="text"
                v-model="formData.Time"
                required
                class="form-control t-a-center"
              />
            </div>
          </div>
          <label>Carichi utilizzati</label>
          <div class="row result-row">
            <div class="form-group col-sm-6">
              <p>Movimento</p>
              <input
                type="text"
                v-model="resultData.Type"
                class="form-control"
              />
            </div>
            <div class="form-group col-sm-6">
              <p>Risultato</p>
              <input
                type="text"
                v-model="resultData.Value"
                class="form-control"
              />
            </div>
          </div>
          
          <div class="row result-add mb-20">
            <a class="btn btn-dark pl-50 pr-50 bg-theme-colored text-white"   @click="addToResults" value="Aggiungi"> <i class="fa fa-plus" ></i> Aggiungi</a>
            </div>

          <div class="row">
            <div class="result-row" v-for="res in formData.LoadList" :key="res.Type">
                <p>{{ res.Type }}: {{ res.Value }}</p>
                <i class="fa fa-remove" @click="removeResult(res.Type)"></i>
            </div>
          </div>

          <div class="row">
            <div class="form-group col-sm-12">
              <label>Sensazioni</label>
              <input
                type="text"
                v-model="formData.Improvments"
                required
                class="form-control t-a-center"
              />
            </div>
          </div>

          
          <div class="row">
            <div class="form-group col-sm-12">
              <label>Movimenti difficili </label>
              <input
                type="text"
                v-model="formData.Difficulties"
                required
                class="form-control t-a-center"
              />
            </div>
          </div>

          <div class="btn-actions">
            <input type="submit" class="btn btn-dark pl-50 pr-50 bg-theme-colored text-white" value="Salva" />
            <input type="button" class="btn btn-dark pl-50 pr-50 text-white" value="Chiudi" @click="closePopup" />
          </div>
      </form>
    </div>
  </div>
</template>

  
  <script>
export default {
   name: "UserTrackModal",
  props: {
    addTrack: {
      type: Boolean,
      required: true,
    },
    userTrack: {
      type: Object,
      required: false,
    },
  },
  watch: {
    userTrack: {
      handler(newValue) {
        if(newValue != null){
this.formData = {
        Time: "",
        Improvments: "",
        Difficulties: "",
        LoadList: []
      };

        this.formData.Time = newValue.Time;
        this.formData.Improvments = newValue.Improvments;
        this.formData.Difficulties = newValue.Difficulties;

        newValue.LoadList.forEach(element => {
          this.formData.LoadList.push({
            
            Type: element.Type,
            Value: element.Value,
          });
        });}
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      formData: {
        Time: "",
        Improvments: "",
        Difficulties: "",
        LoadList: []
      },
      resultData: {
        Type: "",
        Value: "",
      }
    };
  },
  methods: {
    addToResults() {
      this.formData.LoadList.push(this.resultData);

      this.resultData = {
        Type: "",
        Value: "",
      };

    },

    removeResult(name) {
      // Elimina l'ultimo elemento dalla lista dei risultati
      this.formData.LoadList = this.formData.LoadList.filter(x => x.Type != name);
    },

    
    handleSubmit() {
      // Emitti un evento con i dati del form al componente padre
      this.$emit("submit", this.formData);

      this.closePopup();
    },
    closePopup() {
      this.$emit("closeModal");
    },
  },
};
</script>
  
  <style>
.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 20;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: auto; /* Consenti lo scorrimento dell'intero overlay */
}

.popup-content {
  background: white;
  text-align: center;
  border-radius: 5px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  max-height: 70vh; /* Limita l'altezza del popup */
  overflow-y: auto; /* Consenti lo scorrimento verticale */
  width: 50%;
}

@media (max-width: 978px) {
   
.popup-content {
  background: white;
  padding-left: 2vw;
  padding-right: 2vw;
  padding-top: 2vw;
  padding-bottom: 2vw;
  text-align: center;
  border-radius: 5px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  max-height: 70vh; /* Limita l'altezza del popup */
  overflow-y: auto; /* Consenti lo scorrimento verticale */
  width: 90%; /* Assicura che il popup sia reattivo */
}

}

.btn-actions{
    display: flex;
    justify-content: space-evenly;
  margin-top: 20px;
}

.result-row{
display: flex;
}
.result-add{
  margin: auto;
}

.result-row{
    display: flex
;
    flex-direction: row;
    /* align-content: space-between; */
    align-items: baseline;
    justify-content: center;
    gap: 2rem;
}
</style>




  
  